/* unplugin-vue-components disabled */import script from "./TransferDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TransferDialog.vue?vue&type=script&setup=true&lang=js"

import "./TransferDialog.vue?vue&type=style&index=0&id=ce97975c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce97975c"]])

export default __exports__